import React, { useMemo } from "react";
import { ADDON_CATEGORIES } from "./MagicConstants";

/**
 * "Build Your Party" addon picker — shows when user picks the Custom package.
 * Extracted from DoozyGoMagic.js to reduce parent size.
 */
const MagicCustomAddons = ({ customItems, setCustomItems }) => {
  const total = useMemo(() => {
    if (customItems.size === 0) return 0;
    return ADDON_CATEGORIES
      .flatMap(c => c.items)
      .filter(a => customItems.has(a.id))
      .reduce((s, a) => s + a.price, 0);
  }, [customItems]);

  return (
    <div className="bg-gradient-to-r from-[#E83E8C]/5 to-rose-50 rounded-xl p-4 border border-[#E83E8C]/20" data-testid="custom-addon-picker">
      <div className="flex items-center justify-between mb-3">
        <div>
          <p className="text-sm font-bold text-[#1E1B4B]">Build Your Party</p>
          <p className="text-[10px] text-[#94a3b8]">Pick elements you want — min Rs 999</p>
        </div>
        {customItems.size > 0 && (
          <div className="text-right">
            <p className="text-lg font-bold text-[#E83E8C]">Rs {total.toLocaleString()}</p>
            <p className="text-[10px] text-[#94a3b8]">
              {customItems.size} item{customItems.size > 1 ? "s" : ""} selected
            </p>
          </div>
        )}
      </div>
      <div className="space-y-3 max-h-60 overflow-y-auto pr-1">
        {ADDON_CATEGORIES.map(cat => (
          <div key={cat.label}>
            <p className="text-[10px] font-semibold text-[#475569] uppercase tracking-wider mb-1.5">{cat.label}</p>
            <div className="grid grid-cols-1 gap-1">
              {cat.items.map(addon => {
                const selected = customItems.has(addon.id);
                return (
                  <button
                    key={addon.id}
                    onClick={() => {
                      const next = new Set(customItems);
                      if (selected) next.delete(addon.id); else next.add(addon.id);
                      setCustomItems(next);
                    }}
                    className={`flex items-center justify-between px-3 py-2 rounded-lg border text-left transition-all ${
                      selected ? "border-[#E83E8C] bg-[#E83E8C]/5" : "border-gray-200 bg-white hover:border-[#E83E8C]/30"
                    }`}
                    data-testid={`addon-${addon.id}`}
                  >
                    <span className="text-xs text-[#1E1B4B]">{addon.name}</span>
                    <span className={`text-xs font-bold ${selected ? "text-[#E83E8C]" : "text-[#94a3b8]"}`}>
                      Rs {addon.price}
                    </span>
                  </button>
                );
              })}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MagicCustomAddons;
